/**
 * TimelineEventRow — `timeline[row].event` / `timeline[column].event`
 * renderer. Paints an event pill in the parent timeline's slot
 * (column or span, depending on the event's shape).
 *
 * Typed event access goes through the `EVENTS_FACADE` on the parent
 * dataSource — this class only owns visual attributes.
 */
import type { Option } from "../../core/option.ts";
import { Json } from "../../core/json.ts";
import { RendererRow } from "./renderer-row.ts";

/**
 * The timeline event renderer row (`timeline[row].event` / `timeline[column].event`): paints an
 * event pill in its parent timeline.
 */
export class TimelineEventRow extends RendererRow {
  get color(): Option<string> {
    return Json.string(this.attrs(), "color");
  }

  get label(): Option<string> {
    return Json.string(this.attrs(), "label");
  }
}
